export const SearchType_Input = 1
export const SearchType_Select = 2
export const SearchType_BrLine = 3
export const SearchType_Hidden = 4
export const SearchType_Date = 5
export const SearchType_Br = 6
export const SearchType_AutoSelect = 7
export const SearchType_MultiSelect = 8

export class BaseSearchType {
    constructor({type}) {
        this.type = type
    }

    fromJson(jsonData) {
        this.type = jsonData.type
    }
    setVal(val){
        this.val = val
    }
}

export class SearchHidden extends BaseSearchType{
    constructor({key, val, type = SearchType_Hidden}) {
        super({type})
        this.key = key
        this.val = val
    }

    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.key = jsonData.key
        this.val = jsonData.val
    }
}

export class SearchInput extends BaseSearchType {
    constructor({key, val, defaultVal, title, col, type = SearchType_Input}) {
        super({type})
        this.key = key
        this.val = val
        this.defaultVal = defaultVal
        this.title = title
        this.col = col
    }

    fromJson(jsonData) {
        if(jsonData.key === undefined)
            return
        super.fromJson(jsonData)
        this.key = jsonData.key
        this.val = jsonData.val
        this.defaultVal = jsonData.defaultVal
        this.title = jsonData.title
        this.col = jsonData.col
    }
}

export class SearchSelect extends SearchInput {
    constructor({key, val, defaultVal, valType, title, col, row, type = SearchType_Select, attr, n, v, hasBlank, blankVal, blankOption= "全部"}){
        super({key, val, defaultVal, title, col, row, type})
        this.valType = valType
        this.attr = attr
        this.n = n
        this.v = v
        this.hasBlank = hasBlank
        this.blankVal = blankVal
        this.blankOption = blankOption
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.valType = jsonData.valType
        this.attr = jsonData.attr
        this.n = jsonData.n
        this.v = jsonData.v
        this.hasBlank = jsonData.hasBlank
        this.blankVal = jsonData.blankVal
        this.blankOption = jsonData.blankOption
    }
}

export class SearchAutoSelect extends SearchSelect {
    constructor({key, val, defaultVal, valType, title, col, row, type = SearchType_AutoSelect, attr, n, v, hasBlank, blankVal, blankOption= "全部"}){
        super({key, val, defaultVal, valType, title, col, row, type, attr, n, v, hasBlank, blankVal, blankOption})
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
    }
}

export class MultiAutoSelect extends SearchSelect {
    constructor({key, val, defaultVal, valType, title, col, row, type = SearchType_MultiSelect, attr, n, v, hasBlank, blankVal, blankOption= "全部"}){
        super({key, val, defaultVal, valType, title, col, row, type, attr, n, v, hasBlank, blankVal, blankOption})
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
    }
}

export class SearchDate extends SearchInput {
    constructor({key, val, defaultVal, title, col, action, type = SearchType_Date}) {
        super({key, val, defaultVal, title, col, type})
        this.action = action
    }

    fromJson(jsonData) {
        if(jsonData.key === undefined)
            return
        super.fromJson(jsonData)
        this.action = jsonData.action
    }
}

export class SearchBrLine extends BaseSearchType {
    constructor(){
        super({type:SearchType_BrLine})
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
    }
}

export class SearchBr extends BaseSearchType {
    constructor(){
        super({type:SearchType_Br})
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
    }
}
